import {capitalize, downloadFile,translateSiteName , translateSupplyAddress} from "./data-helpers";


export function generateCsvContent(data, headerLayout) {
    let csvContent = "";
    const headingRows = [];
    const supHeadingRows = [];
    for(const heading of headerLayout) {
        if(heading.column === "empty") { continue; } 
        
        const headingText = heading.name || heading.column;
        headingRows.push(capitalize(headingText));
    }

        Object.keys(data[0]).map(function(k){ 
            var exists = false;
            for(const heading of headerLayout) {
                
                if(heading.column === k) //Hackaroo
                {
                    exists = true;
                }
            }
           
            if (exists !== true && k !== "scannedFilePath") {
            supHeadingRows.push(k);
            let headerText = k.replace(/hH(\d+)/, (match, group1) => {
                const minutes = (group1 - 1) * 30; // Subtract 1 to make the first group 0 minutes
                const hh = Math.floor(minutes / 60).toString().padStart(2, "0");
                const mm = (minutes % 60).toString().padStart(2, "0");
                return `${hh}:${mm}`;
            });
            headerText = headerText.replace(/_/g, " ");
            headerText = headerText.replace(/\w\S*/g, (txt) => {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
            if (headerText.startsWith("Hh") && headerText.length <= 4 ) {
                headerText = "00:00";
            }
            //Losing the will
            if (headerText === "Siteaddress" ) {
                headerText = "Site Address";
            }
            else if (headerText === "Metersitekey" ) {
                headerText = "Meter Site Key";
            }else if (headerText === "Sitekey" ) {
                headerText = "Site Key";
            }else if (headerText === "Hhdatatype" ) {
                headerText = "Hh Data Type";
            }else if (headerText === "Companysitename" ) {
                headerText = "Company Site Name";
            }else if (headerText === "Propertyname" ) {
                headerText = "Property Name";
            }
            
            	

            		



            headingRows.push(headerText);
            }

           

            return true;
            })
    

    csvContent += headingRows.join(",") + "\n";

    for(const element of data) {
       var rowContent = []

        for(const heading of headerLayout) {
            if(heading.column === "empty"){ continue; }
            if(heading.name === "Site Name") //Hackaroo
            {
                rowContent.push(translateSiteName(element));
            }else if (heading.name === "Supply Address")
            {
                
                rowContent.push(convertSqlDatetimeToDate(translateSupplyAddress(element)))
            } else
            {
                if(element[heading.column] == null)
                {
                    rowContent.push( ("n/a")); //blank, cleans up null values
                    //rowContent.push("");


                }else
                {
                rowContent.push(convertSqlDatetimeToDate(element[heading.column]));
            }
            }
        }
        //Add aditional Data
        for(const heading of supHeadingRows) {
        if(element[heading] == null)
                {
                    rowContent.push( ("n/a")); //blank, cleans up null values

                }else

                {
                    rowContent.push( convertSqlDatetimeToDate(element[heading])); //allows data to be show as is
                }
            
        }
        csvContent += rowContent.join(",") + "\n";
    }
    
    //Insert Header Modification here
 
   


    return csvContent;
}

export function convertSqlDatetimeToDate(input) {
    // regular expression to match SQL datetime format
    const sqlDatetimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
    const regEx = new RegExp(',', "g");

    if (!sqlDatetimeRegex.test(input)) {
      // if input is not in SQL datetime format, return it unchanged
      if (typeof input === "number") 
        {
            return input;
        }else
        {
            if (input === null || typeof input === "undefined") {
                return input;
              }
                 return input.replace(regEx , ' ');
        }
    }
  
    // parse input as a date object
    const dateObj = new Date(input);
  
    // extract day, month, and year from the date object
    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
  
    // format the date as dd/MM/yyyy
    const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  
    return formattedDate;
  }

export function downloadCsv(csvString, filename){
    downloadFile("data:text/csv;charset=utf-8", encodeURIComponent(csvString), filename);
}